import { Button as ChakraButton, ButtonProps as ChakraButtonProps, forwardRef } from '@chakra-ui/react';
import Icon, { TypeIconName } from '../Icon/Icon';

export interface ButtonProps extends ChakraButtonProps {
  as?: 'a' | 'button';
  disabled?: never;
  isDanger?: boolean;
  leftIconName?: TypeIconName;
  rightIconName?: TypeIconName;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'primary' | 'secondary' | 'tertiary' | 'danger-primary' | 'danger-secondary' | 'danger-tertiary';
}

/**
 * The Button component is used to trigger an action or event, such as submitting a form, opening a dialog, canceling an action, or performing a delete operation.
 */
const Button = forwardRef<ButtonProps, 'button'>((props, ref) => {
  const {
    as = 'button',
    isDanger,
    isDisabled,
    leftIconName,
    rightIconName,
    size = 'lg',
    variant = 'primary',
    ...rest
  } = props;
  const properties: ChakraButtonProps = {
    as: isDisabled ? 'button' : as,
    isDisabled,
    size,
    variant: isDanger && !variant?.includes('danger') ? `danger-${variant}` : variant,
    ...rest,
  };
  const iconSize = size === 'lg' ? '24' : '16';
  if (leftIconName) {
    properties.leftIcon = <Icon name={leftIconName} size={iconSize} />;
  }
  if (rightIconName) {
    properties.rightIcon = <Icon name={rightIconName} size={iconSize} />;
  }
  properties.iconSpacing = properties.children ? '8' : '4';
  return <ChakraButton {...properties} ref={ref} />;
});

export default Button;
